import CourseDetailLayout from '../components/CourseDetailLayout'
import { getSchedule } from '../components/ScheduleTable'
import { useTranslation } from 'react-i18next'
import stretchingMobile01 from '../assets/courses/mobile/stretching-01.jpg'
import stretchingMobile02 from '../assets/courses/mobile/stretching-02.jpg'
import stretchingMobile03 from '../assets/courses/mobile/stretching-03.jpg'
import stretchingDesktop01 from '../assets/courses/desktop/stretching-01.jpg'
import stretchingDesktop02 from '../assets/courses/desktop/stretching-02.jpg'
import stretchingDesktop03 from '../assets/courses/desktop/stretching-03.jpg'

const mobilePics = [stretchingMobile01, stretchingMobile02, stretchingMobile03]
const desktopPics = [stretchingDesktop01, stretchingDesktop02, stretchingDesktop03]

const classes = getSchedule('schedule.stretching')

const StretchingPage = () => {
  const { t } = useTranslation()

  return (
    <CourseDetailLayout
      title={t('nav.stretching')}
      images={mobilePics}
      desktopImages={desktopPics}
      content={[
        t('courses.stretchingDescription'),
        t('courses.stretchingDetails'),
        t('about.thanks'),
      ]}
      classes={classes}
    />
  )
}

export default StretchingPage
